(function () {
    "use strict";

    angular.module("app").directive("signatureBox", SignatureBoxFactory);

    SignatureBoxFactory.$inject = ["$document"];
    function SignatureBoxFactory($document) {
        return {
            scope: {
                linkObject: "=",
                linkField: "@",
                onConfirmed: "=?",
                onCleared: "=?",
                readOnly: "=",
                confirmLabel: "@",
                clearLabel: "@",
            },
            templateUrl: "@/input/signature-box.component.html",
            link: function ($scope, element) {
                const status = {
                    canDraw: !($scope.readOnly),
                    drawing: false
                };

                function getCanvas() {
                    return $(element).find("canvas")[0];
                }
                function getBtnConfirm() {
                    return $(element).find("button")[0];
                }

                const canvas = getCanvas();
                canvas.addEventListener("mousedown", mouseDown, false);
                canvas.addEventListener("mousemove", mouseMove, false);
                canvas.addEventListener("mouseup", stopDrawing, false);
                canvas.addEventListener("mouseleave", stopDrawing, false);

                // touchscreen
                canvas.addEventListener("touchstart", touchStart, false);
                canvas.addEventListener("touchmove", touchMove, false);
                canvas.addEventListener("touchend", stopDrawing, false);

                const btnConfirm = getBtnConfirm();
                $(btnConfirm).prop("disabled", true);

                const drawingHelper = new DrawingHelper(canvas);
                const geometry = new Geometry(canvas);

                let points = [];
                let dataUrl = "";

                function setMode(isEditable) {
                    status.drawing = false;
                    status.canDraw = isEditable;

                    $scope.canEdit = isEditable;

                    $(btnConfirm).prop("disabled", true);
                    $(canvas).prop("disabled", !isEditable);
                    
                    if (isEditable)
                        clearCanvas();
                    else
                        hidePencil();
                }

                initialize();

                $scope.$watch("linkObject", initialize);
                $scope.$watch("readOnly", (newValue, oldValue) => {
                    if (newValue == oldValue)
                        return;
                    setMode(!newValue);
                });

                function initialize() {
                    if (!$scope.linkObject || !$scope.linkField || $scope.linkObject[$scope.linkField] === undefined)
                        return;

                    const signature = $scope.linkObject[$scope.linkField];
                    if (signature !== null) {
                        setMode(false);
                        dataUrl = $scope.linkObject[$scope.linkField];
                        drawingHelper.DrawImage(dataUrl);
                    }
                    else {
                        clearCanvas();
                        setMode(!$scope.readOnly);
                    }
                }

                $scope.confirm = () => {
                    const dataUrl = canvas.toDataURL("image/png");
                    if (angular.isFunction($scope.onConfirmed)) {
                        $scope.onConfirmed(dataUrl, $scope.linkObject);

                        setMode(false);
                    }
                };

                $scope.clear = () => {
                    dataUrl = "";

                    setMode(true);

                    if (angular.isFunction($scope.onCleared))
                        $scope.onCleared(dataUrl, $scope.linkObject);
                };

                function mouseDown(e) {
                    if (!status.canDraw)
                        return;

                    const m = geometry.GetMousePoint(e, canvas);
                    points.push(m);
                    status.drawing = true;
                }

                function mouseMove(e) {
                    if (status.drawing) {
                        const m = geometry.GetMousePoint(e, canvas);
                        points.push(m);
                        drawPoints(points);
                    }
                }

                function stopDrawing() {
                    if (!status.canDraw)
                        return;

                    if (status.drawing) {
                        status.drawing = false;
                        points = [];
                    }
                }

                function touchStart(e) {
                    if (!status.canDraw)
                        return;

                    const m = geometry.GetTouchPoint(e, canvas);
                    points.push(m);
                    status.drawing = true;
                }

                function touchMove(e) {
                    if (status.drawing) {
                        const point = geometry.GetTouchPoint(e, canvas);
                        points.push(point);
                        drawPoints(points);
                    }
                }

                function clearCanvas() {
                    status.drawing = false;

                    drawingHelper.Clear();

                    points = [];

                    showPencil();
                }

                function showPencil() {
                    $(canvas).addClass("pencil");
                }

                function hidePencil() {
                    const signature = $scope.linkObject[$scope.linkField];
                    const dataUrl = canvas.toDataURL("image/png");
                    if (signature === null && dataUrl !== null) {
                        clearCanvas();
                    }

                    $(canvas).removeClass("pencil");
                }

                function drawPoints(points) {
                    if (!status.canDraw)
                        return;

                    drawingHelper.Draw(points);

                    $(btnConfirm).prop("disabled", false);
                }

                // Prevent scrolling when touching the canvas
                $document[0].body.addEventListener("touchstart", CancelTouchScrolling, { passive: false });
                $document[0].body.addEventListener("touchend", CancelTouchScrolling, { passive: false });
                $document[0].body.addEventListener("touchmove", CancelTouchScrolling, { passive: false });

                /**
                 * When a touch event bubbles up ensure we do not start scrolling
                 * @param {Event} e 
                 */
                function CancelTouchScrolling(e) {
                    if (e.target == canvas) {
                        e.preventDefault();
                    }
                }
            },
        };
    }

    /**
     * Helper object for drawing on canvas
     * @param {Canvas} canvas 
     */
    function DrawingHelper(canvas) {
        if (!canvas)
            throw new Error("A canvas is required");

        this.Clear = clear;
        this.DrawImage = drawImage;
        this.Draw = draw;

        const settings = {
            lineWidth: 2.5
        };

        const visual = {
            canvas: canvas,
            context: getContext(canvas)
        };

        function drawImage(dataUrl) {
            const img = new Image;
            img.onload = function () {
                visual.context.drawImage(img, 0, 0);
            };
            img.src = dataUrl;
        }

        // Based on https://stackoverflow.com/a/10568043
        function draw(points) {
            // Fall back to simple drawing method when only a few points are provided
            if (points.length < 6) {
                drawArc(points);
                return;
            }

            visual.context.beginPath();

            // draw a bunch of quadratics, using the average of two points as the control point
            let i;
            for (i = 1; i < points.length - 2; i++) {
                const xMid = (points[i].x + points[i + 1].x) / 2;
                const yMid = (points[i].y + points[i + 1].y) / 2;
                visual.context.quadraticCurveTo(points[i].x, points[i].y, xMid, yMid);
            }

            visual.context.quadraticCurveTo(points[i].x, points[i].y, points[i + 1].x, points[i + 1].y);
            visual.context.stroke();
        }

        function drawArc(points) {
            const startPoint = points[0];
            visual.context.beginPath();
            visual.context.arc(startPoint.x, startPoint.y, settings.lineWidth / 2, 0, Math.PI * 2, !0);
            visual.context.closePath();
            visual.context.fill();
        }

        function clear() {
            visual.context.clearRect(0, 0, canvas.width, canvas.height);
            visual.context.beginPath();
        }

        function getContext(c) {
            const context = c.getContext("2d", { preserveDrawingBuffer: true });
            context.strokeStyle = "#222222";
            context.lineWidth = settings.lineWidth;
            context.lineJoin = "round";
            context.lineCap = "round";
            context.imageSmoothingEnabled = true;
            context.imageSmoothingQuality = "high";

            return context;
        }
    }

    /**
     * Constructor for a helper object used to determine relative positions
     * @param {Canvas} canvas 
     */
    function Geometry(canvas) {
        if (!canvas)
            throw new Error("A canvas is required");

        this.GetMousePoint = getMousePoint;
        this.GetTouchPoint = getTouchPoint;


        // Get the position of a touch relative to the canvas
        function getTouchPoint(touchEvent) {
            const rect = canvas.getBoundingClientRect();
            const touch = touchEvent.touches[0];
            return {
                x: touch.clientX - rect.left,
                y: touch.clientY - rect.top
            };
        }

        function getMousePoint(e) {
            let element = canvas;
            let offsetX = 0, offsetY = 0, mx, my;

            // Compute the total offset. It's possible to cache this if you want
            if (element.offsetParent !== undefined) {
                do {
                    offsetX += element.offsetLeft;
                    offsetY += element.offsetTop;
                } while ((element = element.offsetParent));
            }

            mx = e.pageX - offsetX;
            my = e.pageY - offsetY;

            // We return a simple javascript object with x and y defined
            return { x: mx, y: my };
        }
    }
})();
